import { render, staticRenderFns } from "./CadastroUnidadeMedida.vue?vue&type=template&id=6f0c470e&"
import script from "./CadastroUnidadeMedida.vue?vue&type=script&lang=js&"
export * from "./CadastroUnidadeMedida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports